var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"row"},[_c('zoom-y-transition',[_c('router-view',{key:_vm.$route.fullPath,staticClass:"small-12 medium-12 large-12 hd-12 columns partners-content"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }